import React, { useState } from 'react';

import { sendClientMagicLink } from '../../services/AuthService';

export default function ClientLogin() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await sendClientMagicLink(email);
      setSuccess('Verifique sua caixa de entrada. Enviamos um link de acesso seguro para o seu e-mail.');
    } catch (err) {
      setError(String(err?.message || err || 'Não foi possível enviar o link de acesso.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-md p-8">
        <div className="text-center">
          <div className="text-sm font-extrabold text-[#20243B] uppercase tracking-widest">Portal do Cliente</div>
          <div className="mt-2 text-xs text-gray-600">Informe seu e-mail para receber um link de acesso seguro, sem senha.</div>
        </div>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label className="block text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-1">E-mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="cliente@email.com"
              className="w-full px-3 py-3 text-sm border border-slate-300 rounded-lg outline-none bg-white focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20"
              required
              autoComplete="email"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#20243B] text-white py-3 rounded-lg font-bold shadow-lg hover:bg-[#1a1e30] transition-transform active:scale-95 disabled:opacity-50 text-sm tracking-wider"
          >
            {loading ? 'ENVIANDO...' : 'RECEBER LINK DE ACESSO SEGURO'}
          </button>
        </form>

        {success ? (
          <div className="mt-4 text-xs text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg p-3">
            {success}
          </div>
        ) : null}

        {error ? (
          <div className="mt-4 text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg p-3 whitespace-pre-wrap">
            {error}
          </div>
        ) : null}
      </div>
    </div>
  );
}
